import React from 'react';
import { Download, FileText, FileSpreadsheet } from 'lucide-react';
import { exportToPDF } from '../../utils/exportPDF';
import { exportToCSV } from '../../utils/exportCSV';
import toast from 'react-hot-toast';

const ExportButtons = ({ 
  data, 
  columns, 
  filename = 'relatorio', 
  title = 'Relatório',
  subtitle = null 
}) => {
  const handleExportPDF = () => {
    try {
      exportToPDF(data, columns, { filename, title, subtitle });
      toast.success('PDF exportado com sucesso');
    } catch (error) {
      toast.error('Erro ao exportar PDF');
      console.error(error);
    }
  };

  const handleExportCSV = () => {
    try {
      exportToCSV(data, columns, filename);
      toast.success('CSV exportado com sucesso');
    } catch (error) {
      toast.error('Erro ao exportar CSV');
      console.error(error);
    }
  };

  return (
    <div className="flex gap-2">
      <button
        onClick={handleExportPDF}
        className="px-3 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 flex items-center gap-2"
        title="Exportar PDF"
      >
        <FileText className="w-4 h-4" />
        PDF
      </button>
      <button
        onClick={handleExportCSV}
        className="px-3 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 flex items-center gap-2"
        title="Exportar CSV"
      >
        <FileSpreadsheet className="w-4 h-4" />
        CSV
      </button>
    </div>
  );
};

export default ExportButtons;